import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'departmentsPage',
  setup(__props) {

const departmentsComp = defineAsyncComponent(() => import('@/components/managementPages/dapartmentsPage/departmentsComp.vue'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(departmentsComp)))
}
}

})